import { render, staticRenderFns } from "./ProductTypes.vue?vue&type=template&id=84bb9702&"
import script from "./ProductTypes.vue?vue&type=script&lang=js&"
export * from "./ProductTypes.vue?vue&type=script&lang=js&"
import style0 from "./ProductTypes.vue?vue&type=style&index=0&id=84bb9702&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports